import Vue from "vue";
// 请求
import axios from "axios";
import store from "@/store";
import { router } from "@/router/routerMap.js";

import { EnumRequestFailReasonType } from "@/constants/login.js";

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.headers["cr-referer"] = "cr-mobile";
axios.defaults.withcredentials = true;

Vue.prototype.$axios = axios;

//POST传参序列化(添加请求拦截器)，该序列化方式也是根据实际情况加与不加
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    Vue.prototype.$toast.show({
      text: "传参错误，请检查！",
      type: "text",
      time: 1000,
      width: "auto"
    });
    return Promise.reject(error);
  }
);

let errorCodeMessage = {
  // '10010001': '服务调用失败',
  // '10010002': '注册账号已存在',
  // '10010003': '注册失败',
  // '10010004': '没有权限',
  // '10010005': '操作太频繁',
  // '10010006': '校验码错误',
  // '10010011': '滑动验证码为空',
  // '10010012': '滑动验证码不正确',
  // //'10010008': '登录失败',
  // '10020001': '姓名及证件id值重复，请更新简历！',
  // '10020002': '已存在简历，请更新！',
  // '10020003': '仅能更新自己简历！',
  // '10030001': '仅能投递不超过两个职位！',
  // '10030002': '该职位不存在！',
  // '10030003': '您已投递过该职位，请勿重复投递！',
  // '10030004': '您的简历信息不完整，无法投递，请前往更新！',
  // '10030005': '内推码不能为空！',
  // '10030006': 'HR已查看过您的信息，不能取消投递！',
  // '10010008': '账号或密码错误，登录失败',
  // '10010010': '新密码不能和旧密码一致'
};

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    //对响应数据做判断，与后台协议统一接口返回格式
    if (res.status != 200) {
      //这个判断可根据实际情况修改
      Vue.prototype.$toast.show({
        text: res.data.msg ? res.data.msg : "服务器请求失败，请重试！",
        type: "text",
        time: 1500,
        width: "auto"
      });
      return Promise.reject(res);
    }
    return res.data;
  },
  error => {
    let oriError = error;
    let response = error.response;
    error = (response && response.data) || {
      msg: "请求发生错误，请稍后重试！"
    };
    if (response && response.status == 401) {
      // 梦想驿站相关接口未登录跳转
      if (
        (oriError.config && oriError.config.url.indexOf("/dream") !== -1) ||
        router.currentRoute.path.indexOf("dreamState") !== -1
      ) {
        router.push({ path: "/dreamStateLogin" });
      } else if (
        !(
          (oriError.config &&
            oriError.config.params &&
            oriError.config.params.passLogin) ||
          oriError.config.passLogin
        )
      ) {
        //跳转登录配置
        // AI 链接入口链路：登录后回跳原地址；其余场景维持原有去向
        const cur = router.currentRoute;
        // 已停在登录页时不再导航：重推 /login 会丢掉 query 里已有的 redirect，
        // 登录成功后便回不到目标页（其它未登录接口的 401 可能晚于跳转才返回）
        if (cur.path !== "/login") {
          if (cur.query && cur.query.from === "aiLink") {
            router.push({ path: "/login", query: { redirect: cur.fullPath } });
          } else {
            router.push({ path: "/login" });
          }
        }
      }
      return Promise.reject({
        msg: "未登录，请先登录",
        reasonType: EnumRequestFailReasonType.NOT_LOGIN
      });
    } else {
      const { customError } = error.config || {}

      if (customError) {
        return Promise.reject(error)
      }

      if (error.status && errorCodeMessage[error.status]) {
        return Promise.reject({ msg: errorCodeMessage[error.status] });
      } else if (error.message) {
        if (
          !(
            (oriError.config &&
              oriError.config.params &&
              oriError.config.params.passErrToast) ||
            oriError.config.passErrToast
          )
        ) {
          //自定义toast图标
          Vue.prototype.$toast({
            message: error.message,
            duration: 2000,
            icon: "warning-o"
          });
        }
        return Promise.reject({ msg: error.message, ...error });
      } else {
        Vue.prototype.$toast({
          message: "网络异常，请稍后再试！",
          duration: 2000,
          icon: "warning-o"
        });
        // Vue.prototype.$toast.fail({
        //   message: "网络异常，请稍后再试！",
        //   duration: 2000
        // });
      }
      return Promise.reject(error);
    }
  }
);

axios.defaults.baseURL = store.state.global.baseUrl;



// WEBPACK FOOTER //
// ./src/comm/js/request.js